import React from "react";
import "./PhoneField.css";

function PhoneField({ number, callLink }) {
  return (
    <div className="phone-field py-2">
      <p className="text-left ml-3 mb-0">{number}</p>
      {callLink && (
        <a href={`tel:${number}`}>
          <i className="icon icon-phone text-purple mr-3" />
        </a>
      )}
    </div>
  );
}

export default PhoneField;
